@if (loading()) {
  <app-progress-spinner [enabled]="loading()" />
} @else {
  @if (qrCodeUrl() !== null) {
    <img [src]="qrCodeUrl()" id="qr" />
    <p id="close-note">
      If the image is no longer available, please close and re-open the Facility
      QR Code Dialog.
    </p>
  } @else {
    <p>No QR code exists for this facility currently.</p>
  }
}
